import styled from 'styled-components';

export const FormField = styled.div`
  width: 100%;
  margin-bottom: 8px;
`;

export const Label = styled.label`
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 10px;
  color: #4d4d4d;
`;

interface HelperTextProps {
  error: boolean;
}

export const HelperText = styled.p<HelperTextProps>`
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0em;
  text-align: left;
  color: ${(props) => (props.error ? '#f44336' : '#4d4d4d')};
`;

interface InputProps {
  error: boolean;
}

export const StyledSelect = styled.select<InputProps>`
  color: #595959;
  width: 100%;
  margin-bottom: 4px;
  border-radius: 4px;
  border: 1px solid #999999;
  padding: 12px;
  height: 46px;
  background-color: #ffffff;
  ${(props) => (props.error ? `border-color: #f44336` : '')};
`;
